import React from 'react'

const Footer = () => {
    
    return (
        <>
            
            <footer>
                <div className="footer-content">
                <p>&copy; 2022 - Mendrika Hajaina. All rights reserved.</p>
            
                </div>

            </footer>
            
        </>
    )
}

export default Footer;